import { useEffect, useState } from 'react';
import { getTaskChatMessages, mediaUrl } from '../api/chat';

// XEM LẠI (chỉ đọc) đoạn chat của NHÓM-CỦA-VIỆC đã lưu trữ / đã huỷ.
// chatConvId = id nhóm riêng; onClose đóng modal. Không có ô soạn — thuần xem lại.
const fmt = (d) => { try { return new Date(d).toLocaleString('vi-VN', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit' }); } catch { return ''; } };

export default function TaskChatArchiveModal({ chatConvId, meId, onClose }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    getTaskChatMessages(chatConvId)
      .then((d) => { if (alive) setData(d); })
      .catch((e) => { if (alive) setErr(e?.response?.data?.message || 'Không tải được đoạn chat'); });
    return () => { alive = false; };
  }, [chatConvId]);

  const reasonLabel = data?.reason === 'cancelled' ? 'Đã huỷ (tạo nhầm)' : data?.reason === 'done' ? 'Đã lưu trữ — việc hoàn thành' : 'Đã lưu trữ';

  return (
    <div className="chat-lightbox" onClick={onClose}>
      <div className="taskchat-modal" onClick={(e) => e.stopPropagation()}>
        <div className="taskchat-modal-head">
          <div>
            <b>{data?.name || 'Đoạn chat công việc'}</b>
            <div className="small muted">🗄 {reasonLabel} · chỉ xem lại</div>
          </div>
          <button type="button" className="btn sm ghost" onClick={onClose}>Đóng</button>
        </div>
        <div className="taskchat-modal-body">
          {err ? <div className="small" style={{ color: 'var(--danger)', padding: 10 }}>{err}</div>
            : !data ? <div className="small muted" style={{ padding: 10 }}>Đang tải…</div>
            : !data.messages.length ? <div className="small muted" style={{ padding: 10 }}>Đoạn chat trống.</div>
            : data.messages.map((m) => (
              m.system ? (
                <div key={m._id} className="chat-sysmsg"><span>{m.text}</span></div>
              ) : (
                <div key={m._id} className={'taskchat-msg' + (String(m.sender?._id) === String(meId) ? ' mine' : '')}>
                  <div className="small muted taskchat-msg-who">{m.sender?.name || 'Ẩn'} · {fmt(m.createdAt)}</div>
                  {m.recalled ? <div className="taskchat-bubble recalled">🚫 Tin đã thu hồi</div> : (
                    <div className="taskchat-bubble">
                      {m.text && <div>{m.text}</div>}
                      {(m.attachments || []).map((a, i) => (
                        (a.type || '').startsWith('image/')
                          ? <a key={i} href={mediaUrl(a.url || a.data)} target="_blank" rel="noreferrer"><img className="taskchat-img" src={mediaUrl(a.url || a.data)} alt={a.name} loading="lazy" decoding="async" /></a>
                          : <a key={i} href={mediaUrl(a.url || a.data)} target="_blank" rel="noreferrer" className="chat-att-file">📎 {a.name || 'tệp'}</a>
                      ))}
                    </div>
                  )}
                </div>
              )
            ))}
        </div>
      </div>
    </div>
  );
}
